module.exports = __webpack_public_path__ + "static/media/triangle.336e1c4d.png";